import React, { useEffect, useState } from 'react';
import { Redirect, Switch, Route, useLocation } from 'react-router-dom';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { LayoutSplashScreen } from '../_metronic/layout';
import { Layout } from '../_metronic/layout';
import BasePage from './BasePage';
import ErrorsPage from './modules/ErrorsExamples/ErrorsPage';
import { actions as authActions } from './modules/Auth/_redux/authRedux';
import { getUserByToken, verifyShopifyToken as verifyToken } from './modules/Auth/_redux/authCrud';
import { Logout, AuthPage, OnboardingPage } from './modules/Auth';
import Feed from './modules/Plan-Public';
import { actions as merchantsActions } from '../redux/merchants';
import { getMerchants } from '../app/components/api/merchants';

export function Routes() {
	const [token, setToken] = useState('');
	const location = useLocation();
	const verifyShopifyToken = async ({ shopifyToken }) => {
		const data = await verifyToken({ shopifyToken });
		const { merchants } = data;
		if (!merchants.length) {
			setToken(shopifyToken);
		}
		dispatch(merchantsActions.setMerchants(merchants));
		data.userFulfilled = true
		dispatch(authActions.login(data));
		dispatch(authActions.fulfillUser(data.user));
	}
	const { user, userLoading, userFulfilled } = useSelector(
		({ auth }) => ({
			user: auth.user,
			userLoading: auth.userLoading,
			userFulfilled: auth.userFulfilled,
		}),
		shallowEqual,
	);

	const auth = useSelector(state => state.auth);
	const merchants = useSelector(state => state.merchants.merchants);
	const dispatch = useDispatch();

	useEffect(() => {
		const getUserAndMerchant = async () => {
			const merchantsFound = await getMerchants();
			dispatch(merchantsActions.setMerchants(merchantsFound));
			const user = await getUserByToken();
			dispatch(authActions.fulfillUser(user));
		}
		const shopifyToken = new URLSearchParams(window.location.search).get('token');
		if (auth.authToken && !shopifyToken) {
			getUserAndMerchant();
		} else if (shopifyToken) {
			verifyShopifyToken({ shopifyToken });
		} else {
			dispatch(authActions.fulfillUser(null));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth.authToken, dispatch]);

	return userLoading || (user && !userFulfilled) ? (
		<LayoutSplashScreen />
	) : (
		<Switch>
			<Route path='/error' component={ErrorsPage} />
			<Route path='/logout' component={Logout} />
			<Route path='/onboarding' component={OnboardingPage} />
			<Route exact path='/public-plan' component={Feed} />
			{!user &&
				<Route>
					<AuthPage />
				</Route>}
			{!user &&
				<Route>
					<Redirect to='/auth/login' />
				</Route>
			}
			{(user && userFulfilled) &&
				/*Render auth page when user at `/auth` and not authorized.*/
				<>
					{!merchants.length &&
						<>
							<Route exact path='/'>
								<Redirect to={`/onboarding?token=${token}`} />
							</Route>
							<Route exact path='/auth/login'>
								<Redirect to={`/onboarding?token=${token}`} />
							</Route>
							<Route exact path='/overview'>
								<Redirect to={`/onboarding?token=${token}`} />
							</Route>
						</>
					}
					<Route exact path='/onboarding'>
						<Redirect exact from='/onboarding' to='/' />
					</Route>
					<Route exact path='/auth/login'>
						<Redirect exact from='/' to='/overview' />
					</Route>
					<Route exact path='/'>
						<Redirect exact from='/' to='/overview' />
					</Route>
					<Route>
						<Layout location={location}>
							<BasePage />
						</Layout>
					</Route>
				</>
			}
		</Switch >
	);
}
